import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from '@shared/components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly tenSeconds = 10000 as const;
  private readonly defaultConfig: MatSnackBarConfig = {
    duration: this.tenSeconds,
    horizontalPosition: 'center',
    verticalPosition: 'top',
  };

  private readonly infoConfig: MatSnackBarConfig = {
    ...this.defaultConfig,
    panelClass: ['info-snackbar'],
  };

  private readonly successConfig: MatSnackBarConfig = {
    ...this.defaultConfig,
    panelClass: ['success-snackbar'],
  };

  private readonly warningConfig: MatSnackBarConfig = {
    ...this.defaultConfig,
    panelClass: ['warning-snackbar'],
  };

  private readonly errorConfig: MatSnackBarConfig = {
    ...this.defaultConfig,
    panelClass: ['error-snackbar'],
  };

  private readonly snackBar = inject(MatSnackBar);

  public openInfo(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.infoConfig,
      data: { message, type: 'info' },
      ...config,
    });
  }

  public openSuccess(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.successConfig,
      data: { message, type: 'success' },
      ...config,
    });
  }

  public openWarning(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.warningConfig,
      data: { message, type: 'warning' },
      ...config,
    });
  }

  public openError(message: string, config?: MatSnackBarConfig): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.errorConfig,
      data: { message, type: 'error' },
      ...config,
    });
  }
}
